<template>
    <div>
        <page-title>商盟管理</page-title>
        <page-body>
            <list-header>
                <div flex="dir:right box:last cross:center">
                    <div>
                        <el-input size="mini"
                                  clearable
                                  v-model="search.keyword"
                                  placeholder="关键字检索"
                                  suffix-icon="el-icon-search"
                                  @keyup.enter.native="loadData"></el-input>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="search.loading" :data="list" style="width: 100%">
                <el-table-column prop="id" label="ID" width="80"></el-table-column>
                <el-table-column prop="mobile" label="商盟">
                    <template slot-scope="scope">
                        <div>姓名: {{scope.row.name}}</div>
                        <div>公司: {{scope.row.org_name}}</div>
                        <div>等级: {{scope.row.level ? scope.row.level.name : '-'}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="联系方式">
                    <template slot-scope="scope">
                        <div>手机号: {{scope.row.mobile}}</div>
                        <div>QQ号: {{scope.row.qq_id?scope.row.qq_id:'-'}}</div>
                        <div>微信号: {{scope.row.wechat_id?scope.row.wechat_id:'-'}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="站点/插件/代理">
                    <template slot-scope="scope">
                        <div>站点数: {{scope.row.host_count}}</div>
                        <div>插件订单: {{scope.row.plugin_order_count}}</div>
                        <div>代理数: {{scope.row.agent_count}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="时间">
                    <template slot-scope="scope">
                        <div>添加: {{scope.row.add_time}}</div>
                        <div>更新: {{scope.row.update_time}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.is_delete === 0">
                            <template v-if="scope.row.status === 0">
                                <upload-certificate :item="scope.row" @on-update-status="updateStatus"></upload-certificate>
                            </template>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-if="pagination"
                           style="margin: 20px -5px;padding: 0"
                           background
                           layout="prev, pager, next"
                           :total="pagination.totalCount"
                           :page-size="pagination.pageSize"
                           @current-change="page=>{search.page=page;loadData();}"></el-pagination>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'

export default {
    components: {
        'UploadCertificate': () => import('@/components/UploadCertificate.vue')
    },
    data() {
        return {
            disabled: true,
            search: {
                page: 1,
                keyword: '',
                loading: false
            },
            list: null,
            pagination: null
        }
    },
    methods: {
        updateStatus(mch, url, mark) {
            axios({
                url: 'user/mch/upload',
                method: 'post',
                data: {id: mch.id, certificate_url: url, mark: mark}
            }).then(e => {
                if (e.data.code === 0) {
                    mch.status = 1
                    this.$message.success('操作成功。')
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        loadData() {
            this.search.loading = true
            axios({
                url: 'user/mch/list',
                params: {
                    page: this.search.page,
                    keyword: this.search.keyword
                }
            }).then(e => {
                this.search.loading = false
                if (e.data.code === 0) {
                    this.list = e.data.data.list
                    this.pagination = e.data.data.pagination
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
